module.exports = __webpack_public_path__ + "img/logo-cotizacion.1f52cbaf.png";